export const DESCRIPTION_ID = 'Description'
export const DATE_AND_TIME_ID = 'Date and time'
export const LOCATION_ID = 'Location'
export const HOST_ID = 'Host'
export const PHOTOS_ID = 'Photos'
export const INTERESTS_ID = 'Interests'
export const AVAILABILITY_ID = 'Availability'

export const MOBILE_WIDGET_HEIGHT = '800px'
export const DESKTOP_WIDGET_HEIGHT = '600px'

const DATE_BOX_MOBILE_LIMIT = 6
const DATE_BOX_DESKTOP_TABLET_LIMIT = 8
export const MAX_DATE_BOXES_TO_SHOW = window.innerWidth <= 751 ? DATE_BOX_MOBILE_LIMIT : DATE_BOX_DESKTOP_TABLET_LIMIT

const IMAGES_MOBILE_LIMIT = 3
const IMAGES_DESKTOP_TABLET_LIMIT = 4
export const MAX_IMAGES_TO_SHOW = window.innerWidth <= 751 ? IMAGES_MOBILE_LIMIT : IMAGES_DESKTOP_TABLET_LIMIT
